
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const resendWelcomeMail = createAsyncThunk('employeeProfile/resendWelcomeMail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.post(`${api.resendWelcomeMail}${id}`);
      console.log('resendWelcomeMail response:', response.data);
      if (response.data.success === true) {
        toast.success(response.data.reason, {
          className: "toast-success-custom",
        });
      } else {
        toast.error(response.data.reason, {
          className: "toast-error-custom",
        });
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const resendWelcomeMailSlice = createSlice({
  name: 'resendWelcomeMail',
  initialState: {
    resendWelcomeMail: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(resendWelcomeMail.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(resendWelcomeMail.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.employeeProfile = action.payload;
        })
      .addCase(resendWelcomeMail.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default resendWelcomeMailSlice.reducer;